import { render, staticRenderFns } from "./SignOutRedirect.vue?vue&type=template&id=1cc78bc4&"
import script from "./SignOutRedirect.vue?vue&type=script&lang=js&"
export * from "./SignOutRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports